import { ChangeDetectionStrategy, Component, Input, ChangeDetectorRef, OnInit, OnDestroy } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/delay';
import { Asset } from "app/models/asset";

import swal from "bootstrap-sweetalert";
import { Subscription } from "rxjs/Subscription";
import { AssetService } from "app/services/asset.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ServiceObject, ServiceObjectBase } from "app/models/serviceObject";
import { LocationService } from "app/services/location.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { ServiceObjectSearchComponent } from "app/client/serviceObject/search/serviceObject-search.component";
import { ScrollToAnchorService } from "app/services/scroll-to-anchor.service";
import { PagedResult } from "app/models/PagedResult";
import { ServiceObjectService } from "app/services/serviceObject.service";

@Component({
  templateUrl: './asset-list.component.html',
  styleUrls: ['./asset-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssetListComponent implements OnInit, OnDestroy {

  constructor(
    private _serviceObjectService: ServiceObjectService,
    private _changeDetector: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private router: Router,
    private _scrollToAnchorService: ScrollToAnchorService
  ) { }

  private serviceObjectPathElements: ServiceObjectBase[];
  private _assetPath: Observable<ServiceObjectBase[]>;
  private _serivceObjects: ServiceObject[];
  private _assetsObservable: Observable<PagedResult<ServiceObject>>;
  private _assetsSubscription: Subscription;

  private assetId: number;
  private serviceObjectModalRef: BsModalRef;
  private pagination = {
    id: 'assets_pagination',
    itemsPerPage: 20,
    currentPage: 1,
    totalItems: 0
  }
  private sortBy = "Name";
  private isDesc = false;

  private _errorState: AssetListComponent.ErrorState = AssetListComponent.ErrorState.None;

  ngOnInit() {
    this.activatedRoute.params.subscribe(
      params => {
        this.assetId = + this.activatedRoute.snapshot.params['id'];
        this._assetPath = this._serviceObjectService.getServiceObjectPath(this.assetId)
          .catch(error => {
            console.error("Не удалось загрузить путь к объекту обслуживания", error);
            swal({
              title: 'Ошибка',
              text: 'Не удалось получить путь к объекту обслуживания. Попробуйте снова',
              type: 'error',
              confirmButtonText: 'Попробовать еще раз'
            }, () => {
              window.location.reload();
            });
            return Observable.empty<ServiceObjectBase[]>();
          });

        this.loadPageWithUrlFilterParams();
      });
  }

  ngOnDestroy(): void {
    this.clearSubscription();
    swal.close();

    if(this.serviceObjectModalRef) {
      this.serviceObjectModalRef.hide();
    }
  }

  private openServiceObjectSearchModal() {
    this.serviceObjectModalRef = this.modalService.show(ServiceObjectSearchComponent, { class: 'modal-lg', backdrop: 'static' });
  }

  private setItemsPerPage(itemsPerPage: number): void {
    this.setQueryParams({ count: itemsPerPage });
  }

  private setPage(page: number) {
    this.setQueryParams({ page: page });
  }

  private sort(sortBy: string, isDesc: boolean) {
    this.setQueryParams(
      {
        sortBy: sortBy,
        isDesc: isDesc
      });
  }

  private loadPageWithUrlFilterParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.isDesc = params['isDesc'] ? JSON.parse(params['isDesc']) : this.isDesc;
      this.sortBy = params['sortBy'] ? params['sortBy'] : this.sortBy;
      this.pagination.itemsPerPage = params['count'] ? params['count'] : this.pagination.itemsPerPage;
      this.pagination.currentPage = params['page'] ? params['page'] : this.pagination.currentPage;

      this.clearSubscription();

      this.loadData();
    });
  }

  loadData() {
    this._errorState = AssetListComponent.ErrorState.None;
    // WORKAROUND: без этой строчки изменение поля this._errorState не определяется в разметке
    this._changeDetector.markForCheck();

    this.clearSubscription();

    let newAssetObservable = this._serviceObjectService.getChildrenForParentId(this.assetId, this.sortBy, this.isDesc, this.pagination.itemsPerPage, (this.pagination.currentPage - 1) * this.pagination.itemsPerPage)

    this._assetsObservable = newAssetObservable;

    let itemsObservable = this._assetsObservable
      .subscribe(res => {
        // если на форме сейчас те элементы, которыми управляет данный Observable
        if (newAssetObservable === this._assetsObservable) {
          this.pagination.totalItems = res.totalCount;
          this._serivceObjects = res.items;
          this._changeDetector.markForCheck();
          this.restoreScrollPosition();
        }
      }, error => {
        if (error.status == 403 || error.status == 404) {
          this.router.navigateByUrl('/pagenotfound');
        } else {
          // если на форме сейчас те элементы, которыми управляет данный Observable
          if (newAssetObservable === this._assetsObservable) {
            this._errorState = AssetListComponent.ErrorState.UnknownError;
            // WORKAROUND: без этой строчки изменение поля this._errorState не определяется в разметке
            this._changeDetector.markForCheck();

            swal({
              title: 'Ошибка',
              text: 'Не удалось получить данные объектов обслуживания. Попробуйте снова',
              type: 'error',
              confirmButtonText: 'Попробовать еще раз'
            }, () => {
              this.loadData();
            });
          }
        }
      });
  }

  private clearSubscription() {
    if (this._assetsSubscription)
      this._assetsSubscription.unsubscribe();

    this._assetsSubscription = null;
    this._assetsObservable = null;
    this._serivceObjects = null;
  }

  private setQueryParams(queryParams: object) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        ...this.activatedRoute.snapshot.queryParams,
        ...queryParams
      }
    });
  }

  private goToAssetChildList(elementId : string, assetId : number) {
    let currentUrl = this.router.url.split('#')[0];
    this.router.navigate([`/serviceObject/${assetId}/assets`]);
    window.history.replaceState({}, '', currentUrl + "#" + elementId);
  }

  private goToAssetDetails(elementId : string, assetId : number) {
    let currentUrl = this.router.url.split('#')[0];
    this.router.navigate([`/serviceObject/${assetId}`]);
    window.history.replaceState({}, '', currentUrl + "#" + elementId);
  }

  private restoreScrollPosition() : void {
    const fragment = this.activatedRoute.snapshot.fragment;

    if (fragment) {
      let index = parseInt(fragment.split('_')[1]);
      if (index < this._serivceObjects.length) {
        this._scrollToAnchorService.scroll(fragment);
      } else {
        this._scrollToAnchorService.scroll("row_" + (this._serivceObjects.length - 1));
      }
    }
  }

  private convertAssetStatusToText(status: Asset.Status) {
    switch (status) {
      case Asset.Status.NotInstalled:
        return "Не инсталлирован";
      case Asset.Status.Installed:
        return "Инсталлирован";
      default:
        return "-";
    }
  }

  private ErrorStateEnum = AssetListComponent.ErrorState;
}

export namespace AssetListComponent {

  export enum ErrorState {
    /**
     * Нет ошибок
     */
    None,
    /**
     * Другая ошибка при получении данных с сервера
     */
    UnknownError
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/asset/list/asset-list.component.ts